import axios from 'axios';

// グローバル axios と分離した API 専用インスタンス。
// baseURL や Authorization ヘッダーの設定が他の axios 利用箇所（外部 URL への
// ダウンロードや WMS リクエスト等）へ波及しないようにする。
const api = axios.create({
  baseURL: '/api/v1',
});

export default api;
